import React, { memo } from 'react';

import { Modal } from 'Components/Modal';

import { PurpleButton } from 'Components/Button';

import { InternalAtmosphericLogGroup } from 'Containers/RocketDry/types';

import { areEqual } from 'Utils/equalityChecks';
import classes from './deleteAtmosphericLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;

  // log variable
  atmosphericLogPair: InternalAtmosphericLogGroup;

  // modal functions
  onDeleteButtonClick: (e: any) => void;
  closeModal: (e: any) => void;
}

function DeleteInternalAtmosphericLogModal({ isOpen, atmosphericLogPair, onDeleteButtonClick, closeModal }: Props) {
  return (
    <Modal
      title="Delete Atmospheric Log?"
      isOpen={isOpen}
      classes={classes}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={closeModal}
    >
      <div className={classes.modalBody}>
        <p>
          Are you sure you want to delete this atmospheric log?
          <br />
        </p>
        <div>Inlet</div>
        <div className={classes.logInfo}>
          <div className={classes.logItem}>
            <div>Relative Humidity</div>
            <span>
              {atmosphericLogPair?.inlet?.relativeHumidity ? `${atmosphericLogPair.inlet?.relativeHumidity} %` : ' - '}
            </span>
          </div>
          <div className={classes.logItem}>
            <div>Temperature</div>
            <span>{atmosphericLogPair?.inlet.temperature ? `${atmosphericLogPair.inlet.temperature} °F` : ' - '}</span>
          </div>
          <div className={classes.logItem}>
            <div>Dew Point</div>
            <span>{atmosphericLogPair?.inlet?.dewPoint ? `${atmosphericLogPair.inlet.dewPoint} °F` : ' - '}</span>
          </div>
          <div className={classes.logItem}>
            <div>GPP</div>
            <span>{atmosphericLogPair?.inlet.gpp ?? ' - '}</span>
          </div>
        </div>
        {atmosphericLogPair?.outlet && (
          <>
            <div>Outlet</div>
            <div className={classes.logInfo}>
              <div className={classes.logItem}>
                <div>Relative Humidity</div>
                <span>
                  {atmosphericLogPair?.outlet?.relativeHumidity
                    ? `${atmosphericLogPair.outlet?.relativeHumidity} %`
                    : ' - '}
                </span>
              </div>
              <div className={classes.logItem}>
                <div>Temperature</div>
                <span>
                  {atmosphericLogPair?.outlet.temperature ? `${atmosphericLogPair.outlet.temperature} °F` : ' - '}
                </span>
              </div>
              <div className={classes.logItem}>
                <div>Dew Point</div>
                <span>{atmosphericLogPair?.outlet?.dewPoint ? `${atmosphericLogPair.outlet.dewPoint} °F` : ' - '}</span>
              </div>
              <div className={classes.logItem}>
                <div>GPP</div>
                <span>{atmosphericLogPair?.outlet.gpp ?? ' - '}</span>
              </div>
            </div>
          </>
        )}
        <p>You will not be able to undo this action.</p>
      </div>

      <div className={`modal-footer ${classes.modalFooter}`}>
        <PurpleButton onClick={closeModal} className={classes.cancelButton}>
          Cancel
        </PurpleButton>
        <PurpleButton onClick={onDeleteButtonClick} className={classes.deleteButton}>
          Delete
        </PurpleButton>
      </div>
    </Modal>
  );
}

const DeleteInternalAtmosphericLogModalMemo = memo(DeleteInternalAtmosphericLogModal, areEqual);
export { DeleteInternalAtmosphericLogModalMemo as DeleteInternalAtmosphericLogModal };
